<template>
    <div>
        <v-carousel
            :height="carouselHeight"
            hide-delimiters
        >
            <v-carousel-item
                v-for="(item, index) in items"
                :key="index"
                @click.stop="openOverlay(item)"
            >
                <v-sheet
                    height="100%"
                    color="white"
                >
                    <v-img
                        :src="item"
                        height="100%"
                        contain
                    />
                </v-sheet>
            </v-carousel-item>
        </v-carousel>
        <v-dialog
            v-model="overlay"
            width="1000"
        >
            <v-card class="px-4 py-4">
                <v-img
                    :src="overlayImage"
                    contain
                />
                <v-card-action>
                    <v-btn
                        text
                        @click="overlay=false"
                    >
                        Schließen
                    </v-btn>
                </v-card-action>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: ["items", "rows"],
    data: () => ({
        overlay: false,
        overlayImage: ""
    }),
    computed: {
        carouselHeight: function() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 200
            case 'sm': return 300
            case 'md': return 400
            case 'lg': return 500
            default: return 600
            }
        }
    },
    methods: {
        openOverlay(image) {
            this.overlayImage = image;
            this.overlay = true;
        }
    }
}
</script>

<style lang="scss">
.v-carousel button {
  color: white !important;
  background-color: var(--v-primary-base) !important;
}
</style>